import classes from './NavLinks.module.scss';

const NavLinks = ({ isActive, closeMenu }) => {

  const scrollToSection = (e) => {
    e.preventDefault();
  
    const url = e.target.href.split('#');
    const target = url[url.length - 1].toLowerCase();
    const linkSection = document.getElementById(target);
    linkSection && linkSection.scrollIntoView({ behavior: "smooth", block: "start"});

    closeMenu();
  }

  return (
    <div className={`${classes.navlinks} ${isActive ? classes.active : '' }`}>
      <ul>
        <li className="nav-item"><a href="#home" onClick={scrollToSection}>Home</a></li>
        <li className="nav-item"><a href="#about" onClick={scrollToSection}>About Me</a></li>
        <li className="nav-item"><a href="#services" onClick={scrollToSection}>What I Do</a></li>
        <li className="nav-item"><a href="#portfolio" onClick={scrollToSection}>Portfolio</a></li>
        {/* <li className="nav-item">Contact</li> */}
      </ul>
    </div>
  )
}

export default NavLinks;